import GetProxy from "../GetProxy";
import { api } from "./baseApiSetup";

const proxy = GetProxy();
const EFFICIENCY_BASE_URL = `${proxy}/cmdb/api/v1`;

export const effciencyApi = api.injectEndpoints({
  endpoints: (build) => ({
    getcmdb: build.query({
      query: () => `${EFFICIENCY_BASE_URL}/cmdb/getAllDetailsOfCmdb`,
      transformResponse: (appList) => {
        // Handle case where appList is not an array
        if (!Array.isArray(appList)) {
          return [];
        }
        return appList.map((app) => {
          return {
            label: app.appName + `[${app.appCode}]`,
            value: app.appCode,
            ...app
          };
        });
      },

    }),
    getCmdbDetails: build.query({
      query: ({ id, cacheTimeStamp }) =>
        `${EFFICIENCY_BASE_URL}/cmdb/${id}?_=${cacheTimeStamp}`,
      method: "GET",
    }),
    getOperationRoleDetails: build.query({
      query: () => `${EFFICIENCY_BASE_URL}/licenceUser/operationRole/details`,
      transformResponse: (managerList) => {
        // Handle case where managerList is not an array
        if (!Array.isArray(managerList)) {
          return [];
        }
        return managerList.map((list) => {
          return {
            label: list.fullName + `[${list.userId}]`,
            value: list.fullName,
            id: list.userId,
          };
        });
      },

    }),
    getcmdbCount: build.query({
      query: () => `${EFFICIENCY_BASE_URL}/cmdb/count`,
    }),
    getcmdbList: build.query({
      query: ({ page, limit }) =>
        `${EFFICIENCY_BASE_URL}/cmdb/list/${page}/${limit}`,
    }),
    // getcmdbProjectCount: build.query({
    //   query: ({ id }) => `${EFFICIENCY_BASE_URL}/cmdb/${id}/projects/count`,
    // }),

    // getcmdbProjectList: build.query({
    //   query: ({ id, page = 0, limit = 10 }) =>
    //     `${EFFICIENCY_BASE_URL}/cmdb/${id}/projects/${page}/${limit}`,
    // }),
    importCmdb: build.mutation({
      query: ({ formData, userName }) => ({
        url: `${EFFICIENCY_BASE_URL}/cmdb/import/${userName}`,
        method: "POST",
        body: formData
      })
    }),
    getFilteredCmdbCount: build.mutation({
      query: (postBody = {}) => ({
        url: `${EFFICIENCY_BASE_URL}/cmdb/filter/count`,
        method: "POST",
        body: postBody,
      }),
    }),
    getFilteredCmdbList: build.mutation({
      query: (postBody = {}, page = 0, limit = 10) => ({
        url: `${EFFICIENCY_BASE_URL}/cmdb/filter/${page}/${limit}`,
        method: "POST",
        body: postBody,
      }),
    }),
    getProjectType: build.query({
      query: (cacheTimeStamp) =>
        `${EFFICIENCY_BASE_URL}/toolsPlugin`,
    }),
    getProjectTool: build.query({
      query: ({ type, cacheTimeStamp }) =>
        `${EFFICIENCY_BASE_URL}/toolsPlugin/${type}?_=${cacheTimeStamp}`,
    }),
    addManageProject: build.mutation({
      query: ({ payload, id, userName }) => ({
        url: `${EFFICIENCY_BASE_URL}/project/cmdb/${id}/project/${userName}`,
        method: "POST",
        body: payload,
      }),
    }),
    deleteProject: build.mutation({
      query: ({ id, userName }) => ({
        url: `${EFFICIENCY_BASE_URL}/project/deleteProject/${id}/${userName}`,
        method: "DELETE",
      }),
    }),
    checkAppCode: build.query({
      query: ({ appCode, id, cacheTimeStamp }) =>
        `${EFFICIENCY_BASE_URL}/cmdb/checkAppCode/${appCode}/${id}?_=${cacheTimeStamp}`,
    }),
    postApplicationDetails: build.mutation({
      query: ({ payload, userName }) => ({
        url: `${EFFICIENCY_BASE_URL}/cmdb/saveAndUpdateCMDBDetails/${userName}`,
        method: "POST",
        body: payload,
      }),
    }),
    deleteApplication: build.mutation({
      query: ({ id, userName }) => ({
        url: `${EFFICIENCY_BASE_URL}/cmdb/deleteCMDBDetails/${id}/${userName}`,
        method: "DELETE",
      }),
    }),
    importProject: build.mutation({
      query: ({ id, payload, userName }) => ({
        url: `${EFFICIENCY_BASE_URL}/project/import/${id}/${userName}`,
        method: "POST",
        body: payload,
      }),
    }),
    //onBoarding API
    getToolsList: build.query({
      query: () => `${EFFICIENCY_BASE_URL}/tools/list`,
    }),
    getProjects: build.query({
      query: (id) => `${EFFICIENCY_BASE_URL}/onboarding/cmdb/${id}/projectList`,
    }),
    getProjectProjectList: build.query({
      query: ({ id, projectId = "nullString" }) =>
        `${EFFICIENCY_BASE_URL}/onboarding/cmdb/${id}/${projectId}/projectList`,
    }),
    callJiraVersion: build.query({
      query: () => `${EFFICIENCY_BASE_URL}/tools/toolsInfoForJira/jira`,
    }),
    callJiraCloudVersion: build.query({
      query: () =>
        `${EFFICIENCY_BASE_URL}/tools/toolsInfoForJiraCloud/jira cloud`,
    }),
    callSonarQubeVersion: build.query({
      query: () =>
        `${EFFICIENCY_BASE_URL}/tools/toolsInfoForSonarqube/sonarqube`,
    }),
    callBitbucketVersion: build.query({
      query: () =>
        `${EFFICIENCY_BASE_URL}/tools/toolsInfoForBitbucket/bitbucket`,
    }),
    callConfluenceCloudVersion: build.query({
      query: () =>
        `${EFFICIENCY_BASE_URL}/tools/toolsInfoForConfluenceCloud/ConfluenceCloud`,
    }),
    callJfrogVersion: build.query({
      query: () => `${EFFICIENCY_BASE_URL}/tools/toolsInfoForJfrog/Jfrog`,
    }),
    getOnboardInput: build.query({
      query: ({ id, projectId }) =>
        `${EFFICIENCY_BASE_URL}/onboarding/cmdb/${id}/${projectId}/inputList`,
    }),
    //onBoarding-  Plan
    getProjectLeads: build.query({
      query: () => `${EFFICIENCY_BASE_URL}/licence/user/license/user/list`,
    }),
    checkDuplicateProjectKey: build.query({
      query: (projectKey) =>
        `${EFFICIENCY_BASE_URL}/jira/check/${projectKey}/exist`,
    }),
    getJiraUsers: build.query({
      query: () => `${EFFICIENCY_BASE_URL}/jira/users`,
    }),
    getMember: build.query({
      query: (memberId) =>
        `${EFFICIENCY_BASE_URL}/directory/get/members/details/${memberId}`,
    }),
    checkDBExists: build.mutation({
      query: (postBody) => {
        return {
          url: `${EFFICIENCY_BASE_URL}/onboarding/isDBExists`,
          method: "POST",
          body: postBody,
        };
      },
    }),
    toolRequest: build.mutation({
      query: ({ payload, cmdbId }) => {
        return {
          url: `${EFFICIENCY_BASE_URL}/onboarding/cmdb/${cmdbId}/toolrequest`,
          method: "POST",
          body: payload,
        };
      },
    }),
    dBToolRequest: build.mutation({
      query: ({ postBody, cmdbId }) => {
        return {
          url: `${EFFICIENCY_BASE_URL}/onboarding/cmdb/${cmdbId}/db/toolrequest`,
          method: "POST",
          body: postBody,
        };
      },
    }),
    //Access Management
    getManagerDetails: build.query({
      query: (id) => `${EFFICIENCY_BASE_URL}/cmdb/${id}`,
    }),
    getUserDetails: build.query({
      query: () => `${EFFICIENCY_BASE_URL}/licence/user/details`,
    }),
    getGroups: build.query({
      query: () => `${EFFICIENCY_BASE_URL}/groups`,
    }),
    getOnBoardTools: build.query({
      query: ({ id, projectId = "nullString" }) =>
        `${EFFICIENCY_BASE_URL}/cmdb/${id}/project/${projectId}`,
    }),
    getGroupMembers: build.query({
      query: ({ id, projectId = "ALL" }) =>
        `${EFFICIENCY_BASE_URL}/directory/get/group/member/list/${id}/${projectId}`,
    }),
    requestAccess: build.mutation({
      query: ({ id, projectId, payload }) => {
        return {
          url: `${EFFICIENCY_BASE_URL}/directory/access/request/${id}/${projectId}`,
          method: "POST",
          body: payload,
        };
      },
    }),
    // my Approval
    getMyApprovalCount: build.query({
      query: (userName) => `${EFFICIENCY_BASE_URL}/tasks/count/${userName}`,
    }),
    getMyApprovalList: build.query({
      query: ({ page, count, userName }) => `${EFFICIENCY_BASE_URL}/tasks/${userName}/${page}/${count}`,
    }),
    getRequestDetails: build.query({
      query: ({ id, type }) => `${EFFICIENCY_BASE_URL}/tasks/${type}/${id}`
    }),
    //Audit Log
    getAuditLogCount: build.query({
      query: () => `${EFFICIENCY_BASE_URL}/auditLog/count`,
    }),
    getAuditList: build.query({
      query: ({ page, count }) => `${EFFICIENCY_BASE_URL}/auditLog/list/${page}/${count}`,
    }),
    approveRequest: build.mutation({
      query: ({ payload, taskId }) => {
        return {
          url: `${EFFICIENCY_BASE_URL}/tasks/approve/${taskId}`,
          method: "POST",
          body: payload
        };
      }
    }),
    rejectRequest: build.mutation({
      query: ({ payload, taskId }) => {
        return {
          url: `${EFFICIENCY_BASE_URL}/tasks/reject/${taskId}`,
          method: "POST",
          body: payload
        };
      }
    }),
    //my Request
    getMyRequestCount: build.query({
      query: (userName) => `${EFFICIENCY_BASE_URL}/myRequest/${userName}/count`,
    }),
    getMyRequestList: build.query({
      query: ({ page, limit, userName }) => `${EFFICIENCY_BASE_URL}/myRequest/${userName}/list/${page}/${limit}`,
    }),
    getMyRequestAccessDetails: build.query({
      query: (reqId) => `${EFFICIENCY_BASE_URL}/myRequest/onboarding/request/config/${reqId}`,
    }),
    getMyRequestToolDetails: build.query({
      query: (reqId) => `${EFFICIENCY_BASE_URL}/myRequest/onboarding/request/tools/${reqId}`,
    }),
    getFilteredRequestCount: build.mutation({
      query: (postBody = {}) => ({
        url: `${EFFICIENCY_BASE_URL}/myRequest/filter/count`,
        method: "POST",
        body: postBody
      })
    }),
    getFilteredRequestList: build.mutation({
      query: ({ payload, page, limit }) => ({
        url: `${EFFICIENCY_BASE_URL}/myRequest/filter/${page}/${limit}`,
        method: "POST",
        body: payload
      })
    }),
    //Server Page API's
    // getServerList: build.mutation({
    //   query: ({ payloadid, page, limit }) => ({
    //     // url: `${EFFICIENCY_BASE_URL}/server/list/${cmdbId}`,
    //     url: `${EFFICIENCY_BASE_URL}/server/list/${payloadid}/${page}/${limit}`,
    //     method: "GET",

    //   })
    // }),
    getServerdelete: build.mutation({
      query: ({ id, userName }) => ({
        url: `${EFFICIENCY_BASE_URL}/server/delete/${id}/${userName}`,
        method: "DELETE",

      })
    }),
    getServerSave: build.mutation({
      query: ({ cmdbId, payload, userName }) => ({
        // url: `${EFFICIENCY_BASE_URL}/server/cmdb/${cmdbId}/server`,
        url: `${EFFICIENCY_BASE_URL}/server/cmdb/${cmdbId}/server/${userName}`,
        method: "POST",
        body: payload,
      }),
    }),
    getCheckIP: build.mutation({
      query: ({ cmdbId, ip, id }) => ({
        url: `${EFFICIENCY_BASE_URL}/server/checkIP/${ip}/${id}/${cmdbId}`,
        method: "GET",
      }),
    }),
    getCheckServerName: build.mutation({
      query: ({ cmdbId, deviceName, id }) => ({
        url: `${EFFICIENCY_BASE_URL}/server/checkServerName/${deviceName}/${id}/${cmdbId}`,
        method: "GET",
      }),
    }),
    // getServerCount: build.mutation({
    //   query: ({ id }) => ({
    //     url: `${EFFICIENCY_BASE_URL}/server/${id}/server/count`,
    //     method: "GET",
    //   }),
    // }),
    getAllServerConfigInfo: build.mutation({
      query: ({cmdbId}) => ({
        url: `${EFFICIENCY_BASE_URL}/serverConfigInfo/GetAllServerConfigInfo/${cmdbId}`,
        method: "GET",
      }),
    }),
    //Application ID Confiq
    // getAccountIdContList: build.mutation({
    //   query: (payloadid) => ({
    //     url: `${EFFICIENCY_BASE_URL}/CSPForAws/listById/${payloadid}`,
    //     method: "GET",
    //   }),
    // }),
    //User ID Confiq
    // getUserListId: build.mutation({
    //   query: (payloadid) => ({
    //     url: `${EFFICIENCY_BASE_URL}/LDAPCMDBUserConfig/${payloadid}/count`,
    //     method: "GET",
    //   }),
    // }),
    getBusinessInfoListCMDB: build.mutation({
      query: () => ({
        url: `${EFFICIENCY_BASE_URL}/businessInfoConfig/list/BusinessInfoConfig/division`,
        method: "GET",
      }),
    }),
    // getUserListPagination: build.mutation({
    //   query: ({ payloadid, page, limit }) => ({
    //     url: `${EFFICIENCY_BASE_URL}/LDAPCMDBUserConfig/list/${payloadid}/${page}/${limit}`,
    //     method: "GET",
    //   }),
    // }),
    getUserListSave: build.mutation({
      query: ({ payloadid }) => ({
        url: `${EFFICIENCY_BASE_URL}/UserAccessRest/usersListById/${payloadid}`,
        method: "POST",
      })
    }),
    getUserAdd: build.mutation({
      query: (payloadid) => ({
        url: `${EFFICIENCY_BASE_URL}/UserAccessRest/usersListAddOrRemove/${payloadid}`,
        method: "GET",
      })
    }),
    getUserDetailsAppConfig: build.mutation({
      query: () => ({
        url: `${EFFICIENCY_BASE_URL}/directory/get/members/details`,
        method: "GET",
      })
    }),
    getUserConfig: build.mutation({
      query: () => ({
        url: `${EFFICIENCY_BASE_URL}/LDAPDashboard/UserInfoForCmdb`,
        method: "GET",
      })
    }),
    getUserAppcode: build.mutation({
      query: (payloadid) => ({
        url: `${EFFICIENCY_BASE_URL}/cmdb/${payloadid}`,
        method: "GET",
      })
    }),
    getUserListUpdate: build.mutation({
      query: ({ payload, payloadid, userName }) => ({
        url: `${EFFICIENCY_BASE_URL}/LDAPCMDBUserConfig/saveAndUpdate/${payloadid}/${userName} `,
        method: "POST",
        body: payload,
      })
    }),
    getUserListReview: build.mutation({
      query: (payload) => ({
        url: `${EFFICIENCY_BASE_URL}/UserAccessRest/userReviewer `,
        method: "POST",
        body: payload,
      })
    }),
    getUserListDate: build.mutation({
      query: (payloadid) => ({
        url: `${EFFICIENCY_BASE_URL}/UserAccessRest/save/${payloadid} `,
        method: "POST",
      })
    }),
    getUserDueDate: build.mutation({
      query: (payloadid) => ({
        url: `${EFFICIENCY_BASE_URL}/UserAccessRest/dueDate/${payloadid}`,
        method: "GET",
      })
    }),
    getReviewAccess: build.mutation({
      query: (payload) => ({
        url: `${EFFICIENCY_BASE_URL}/UserAccessRest/userAccessReviewerNameList `,
        method: "POST",
        body: payload,
      })
    }),
    getDeleteUserReviewer: build.mutation({
      query: (payload) => ({
        url: `${EFFICIENCY_BASE_URL}/UserAccessRest/deleteReviewerName `,
        method: "POST",
        body: payload,
      })
    }),
    getUserdelete: build.mutation({
      query: ({ payloadid, userName, uID }) => ({
        url: `${EFFICIENCY_BASE_URL}/LDAPCMDBUserConfig/delete/${payloadid}/${userName}/${uID}`,
        method: "DELETE",
      }),
    }),

    getUserAccessReviewAlert: build.mutation({
      query: (payload) => ({
        url: `${EFFICIENCY_BASE_URL}/UserAccessRest/alertRequestMail`,
        method: "POST",
        body: payload,
      }),
    }),

    getUserAccessDueDate: build.mutation({
      query: (payload) => ({
        url: `${EFFICIENCY_BASE_URL}/UserAccessRest/AccessDueDate`,
        method: "POST",
        body: payload,
      })
    }),

    // CSP List

    getCSPList: build.mutation({
      query: ({ appCode }) => ({
        url: `${EFFICIENCY_BASE_URL}/CSPForAws/CSPAccountList/${appCode}`,
        method: "GET",
      }),
    }),
    getCspListById: build.mutation({
      query: (payloadid) => ({
        url: `${EFFICIENCY_BASE_URL}/CSPForAws/listById/${payloadid}`,
        method: "GET",
      }),
    }),
    getCspListPagination: build.mutation({
      query: ({ payloadid, page, limit }) => ({
        url: `${EFFICIENCY_BASE_URL}/CSPForAws/list/${payloadid}/${page}/${limit}`,
        method: "GET",
      }),
    }),
    getCspCount: build.mutation({
      query: ({ payloadid }) => ({
        url: `${EFFICIENCY_BASE_URL}/CSPForAws/${payloadid}/count`,
        method: "GET",
      }),
    }),
    getCspSaveOrUpdate: build.mutation({
      query: ({ payload, payloadid, userName }) => ({
        url: `${EFFICIENCY_BASE_URL}/CSPForAws/saveOrUpdateCloudAccountsWithCmdb/${payloadid}/${userName}`,
        method: "POST",
        body: payload
      })
    }),
    getCspDelete: build.mutation({
      query: ({ id, userName }) => ({
        url: `${EFFICIENCY_BASE_URL}/CSPForAws/deleteCMDBMappedCloudAccounts/${id}/${userName}`,
        method: "DELETE",
      })
    }),
    getCspAccountList: build.mutation({
      query: () => ({
        url: `${EFFICIENCY_BASE_URL}/CSPForAws/getCspAccountList`,
        method: "GET",
      }),
    }),
    getCspDrildown: build.mutation({
      query: ({ accountId }) => ({
        url: `${EFFICIENCY_BASE_URL}/awsIam/CSPUserList/${accountId}`,
        method: "GET",
      })
    }),

    //servers - CMDB

    getServersInfoCMDB: build.mutation({
      query: () => ({
        url: `${EFFICIENCY_BASE_URL}/serverConfigInfo/list`,
        method: "GET",
      })
    }),

    getServerInfoSaveCMDB: build.mutation({
      query: ({ payload }) => ({
        url: `${EFFICIENCY_BASE_URL}/serverConfigInfo/saveOrUpdateServerConfigInfo`,
        method: "POST",
        body: payload,
      }),
    }),

    getServerInfodelete: build.mutation({
      query: ({ id }) => ({
        url: `${EFFICIENCY_BASE_URL}/serverConfigInfo/delete/${id}`,
        method: "DELETE",
      }),
    }),

    getServersInfoGetID: build.mutation({
      query: ({ id }) => ({
        url: `${EFFICIENCY_BASE_URL}/serverConfigInfo/getById/${id}`,
        method: "GET",
      })
    }),

  }),
  overrideExisting: true,
});

